import { BaseApiRequestParams, BaseListResponse, CategoryOrderBy, GerberaRequestFactory, mapToRequestParams } from './core'

// GET カテゴリの一覧を取得するリクエスト際の時に必要な情報
export interface GetCategoryListRequest {
  siteId: number
  page?: number
  perPage?: number
  orderBy?: CategoryOrderBy[]
}

// GET カテゴリの一覧を取得するリクエストのうちGETパラメータに載せる情報
interface GetCategoryListRequestParams {
  page?: number | ''
  perPage?: number | ''
  orderBy?: string
}

// カテゴリを表すデータのモデル定義
export interface CategoryItem {
  categoryId: number | null
  categoryName: string,
  siteId: number,
  contentCount: number,
  siteItemInfo?: SiteItemInfo
  createdDate?: string,
  modifiedDate?: string
}

export interface SiteItemInfo {
  isPublished?: boolean,
  previewUrl?: string
  settingUrl?: string
  pagePath?: string
}

export interface GetCategoryListResponse extends BaseListResponse<CategoryItem> {
}

export interface GetCategoryWholeResponse extends CategoryItem {
}

/**
 * コンテンツサービス(カテゴリ)のエンドポイント
 */
export interface ICategoriesEndpoint {
  // カテゴリの一覧を取得する
  getCategoryList(request: GetCategoryListRequest): Promise<GetCategoryListResponse>

  // カテゴリの全記事一覧のデータを取得する
  getCategoryWhole(siteId: number): Promise<GetCategoryWholeResponse>
}

export default class CategoryEndpoint implements ICategoriesEndpoint {
  // カテゴリの一覧を取得する
  getCategoryList(request: GetCategoryListRequest): Promise<GetCategoryListResponse> {
    const baseRequest = Object.assign(<BaseApiRequestParams>{}, request)
    const baseParams = mapToRequestParams(baseRequest)
    const params = Object.assign(<GetCategoryListRequestParams>{}, baseParams)
    const path = `/sites/${request.siteId}/categories`
    return GerberaRequestFactory.getRequest().execute<GetCategoryListRequestParams, GetCategoryListResponse>(path, params)
      .then(response => response.data)
  }

  // カテゴリの全記事一覧のデータを取得する
  getCategoryWhole(siteId: number): Promise<GetCategoryWholeResponse> {
    const path = `/sites/${siteId}/categories/whole`
    return GerberaRequestFactory.getRequest().execute<GetCategoryWholeResponse>(path)
      .then(response => response.data)
  }
}
